export default __webpack_public_path__ + "static/martha-geilman-cac6a7a407fdfff456e1e16b4b71c916.png";